import { useTranslation } from 'react-i18next';
import { showcaseProducts } from '@/mocks/categories';

export default function ProductShowcaseSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-light text-foreground-900 mb-2">
            {t('showcase.title')}
          </h2>
          <p className="text-base text-foreground-500">
            {t('showcase.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {showcaseProducts.map((product) => (
            <div key={product.id} className="flex flex-col">
              <div className="relative w-full aspect-square rounded-2xl overflow-hidden bg-background-100 mb-4">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 text-center mb-1">
                {product.name}
              </h3>
              <p className="text-sm text-foreground-500 text-center mb-4">
                {product.price}
              </p>
              <a
                href={product.url}
                target="_blank"
                rel="noopener nofollow"
                className={`inline-flex items-center justify-center w-full px-6 py-3 rounded-full text-sm font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap ${
                  product.featured
                    ? 'bg-foreground-900 text-background-50 hover:bg-foreground-800'
                    : 'border-2 border-foreground-200 text-foreground-700 hover:border-foreground-400 hover:text-foreground-900'
                }`}
              >
                {t('cta.buyItNow')}
              </a>
            </div>
          ))}
        </div>

        <p className="text-center text-xs text-foreground-400 mt-6">
          * Ceny orientacyjne, mogą się różnić w zależności od sprzedawcy
        </p>
      </div>
    </section>
  );
}